var $ = require("jquery");
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

var hpHeroSlider = new Swiper('.hp-hero__slider', {
    slidesPerView: 1,
    loop: true,
    effect: 'fade',
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: '.hp-hero__slider .swiper-pagination',
      clickable: true
    },
});

 $(".hp-hero__slider__nav .autoplay-toggle").on('click', function(e) {
  if($(this).hasClass('pause')) {
    hpHeroSlider.autoplay.stop();
    $(this).removeClass('pause').addClass('play').attr("aria-label","Play slider")
  } else {
    hpHeroSlider.autoplay.start();
    $(this).removeClass('play').addClass('pause').attr("aria-label","Pause slider")
    $(this).arrt
  }
});

var latestNewsSlider = new Swiper('.latest-news__slider .swiper', {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    navigation: {
      nextEl: ".latest-news__slider__next",
      prevEl: ".latest-news__slider__prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1025: {
        slidesPerView: 3,
        spaceBetween: 30,
      }
    },
});


var videoEmbedSlider = new Swiper('.video-embeds__wrap .swiper', {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: false,
    navigation: {
      nextEl: ".video-embeds__wrap__next",
      prevEl: ".video-embeds__wrap__prev",
    },
});

var imagesSlider = new Swiper('.images-block__wrap--slider', {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: false,
    navigation: {
      nextEl: ".images-block__nav__next",
      prevEl: ".images-block__nav__prev",
    },
     pagination: {
      el: '.images-block__wrap--slider .swiper-pagination',
      clickable: true,
      dynamicBullets: true,
    },
});
